/*import {createStore} from 'vuex'
import cart from './modules/cart1'
import login from './modules/login'

export default createStore({
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {

    },
    modules: {
        cart,login
    },

})*/

import { createStore } from 'vuex'
import cart from './modules/cart'
// import login from './modules/login'
export default createStore({
    state: {
        token: null,
        user: null
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        clearToken(state) {
            state.token = null
        },
        setUser(state, user) {
            state.user = user
        },
        clearUser(state) {
            state.user = null
        }
    },
    getters: {
        getToken: (state) => state.token,
        getUser: (state) => state.user,
        isLoggedIn: (state) => !!state.user,
        isAuthenticated: (state) => !!state.user

    },

    modules: {
        cart,
        // login
    }

})
